<template>
  <section id="about">
    <div class="hero-image">
      <img src="../../static/static-css/img/about-us/about.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="dasboard-content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="tittle">
              <h3>Website Terms and Conditions Of Use</h3>
            </div>
            <div class="content" v-if="userLocation !== null && userLocation === 'AE'">
              <h5 class="content-heading">Our Terms</h5>
              <ol>
                <li>
                  <p>
                    These Terms explain how you may use this website (the Site).
                  </p>
                </li>
                <li>
                  <p>
                    References in these Terms to the Site includes the following websites and all associated subdomains and web pages:
                    <!-- <br> -->
                    <a href="http://www.fintransformer.com">www.fintransformer.com</a>
                  </p>
                </li>
                <li>
                  <p>
                    You should read these Terms carefully before using the Site.
                  </p>
                </li>
                <li>
                  <p>
                    By accessing or using the Site or otherwise indicating your consent, you agree to be bound by these Terms and the documents referred to in them.
                  </p>
                </li>
                <li>
                  <p>
                    If you do not agree with or accept any of these Terms, you should stop using the Site immediately.
                  </p>
                </li>
                <li>
                  <p>
                    If you have any questions about the Site, please contact us by: <a href="mailto:fintransformer@gmail.com">fintransformer@gmail.com</a>
                  </p>
                </li>
                <li>
                  <h5 class="point-heading">
                    Definitions
                  </h5>
                  <h6 class="definition-heading">
                    Content
                  </h6>
                  <p>
                    Means any text, images, video, audio or other multimedia content, software or other information or material submitted to or on the Site.
                  </p>
                  <h6 class="definition-heading">
                    Terms
                  </h6>
                  <p>
                    Means these terms and conditions of use as updated from time to time.
                  </p>
                  <h6 class="definition-heading">
                    Intellectual property rights
                  </h6>
                  <p>
                    Means rights such as copyright, trade marks, domain names, design rights, database rights, patents and all other intellectual property rights of any kind whether or not they are registered or unregistered (anywhere in the world).
                  </p>
                  <h6 class="definition-heading">
                    Unwanted Submission
                  </h6>
                  <p>
                    Has the meaning given to it in the section entitled "submitting information to the site".
                  </p>
                  <h6 class="definition-heading">
                    Cookie policy
                  </h6>
                  <p>
                    Means the <a href="/privacy-policy">privacy policy</a>, which governs how we use cookies in the Site.
                  </p>
                  <h6 class="definition-heading">
                    Online terms and conditions of sale
                  </h6>
                  <p>
                    Means the <a href="/tandscales">terms and conditions</a>, which will apply to you ordering goods, services and/or digital content using the Site.
                  </p>
                  <h6 class="definition-heading">
                    Privacy policy
                  </h6>
                  <p>
                    Means the <a href="/privacy-policy">privacy policy</a>, which governs how we process any personal data collected from you.
                  </p>
                  <h6 class="definition-heading">
                    Site
                  </h6>
                  <p>
                    Has the meaning given to it in clause 1.1.
                  </p>
                  <h6 class="definition-heading">
                    We, us or our
                  </h6>
                  <p>
                    means the owner’s office of which is at:
                  </p>
                  <p class="text-center">
                    P. O. Box 1400, Dubai, United Arab Emirates
                  </p>
                  <p>
                    References to us in these Terms also includes any group companies which we may have from time to time.
                  </p>
                  <h6 class="definition-heading">
                    You or your
                  </h6>
                  <p>
                    Means the person accessing or using the Site or its Content.
                  </p>
                </li>
                <li>
                  <p>Your use of the Site means that you must also comply (where applicable) with:</p>
                  <ul>
                    <li>
                      <p>
                        Our
                        <a href="/tandcsales">
                          Online terms and conditions of sale
                        </a> .
                      </p>
                    </li>
                    <li>
                      <p>
                        Our
                        <a href="/privacy-policy">
                          privacy policy
                        </a> .
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  <p>
                    We reserve the right, at our sole discretion, to change, modify, add or remove portions of these Terms of Use, at any time. It is your responsibility to check these Terms of Use periodically for changes. Your continued use of the Site following the posting of changes will mean that you accept and agree to the changes.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">Using the Site</h5>
              <ol>
                <li>
                  <p>The Site is for your personal and non-exclusive use only. As long as you comply with these Terms of Use The owner grants you a personal, non-exclusive, non-transferable, limited privilege to enter and use the Site.</p>
                </li>
                <li>
                  <p>
                    You may not use any "page-scraper", "robot", "spider", "deep-link" or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to access, copy, acquire, or monitor any part of the Site, or in any way reproduce or circumvent the navigational structure or presentation of the Site or any Content, to obtain or attempt to obtain any materials, documents or information through any means not purposely made available through the Site.
                  </p>
                </li>
                <li>
                  <p>
                    You may not attempt to gain unauthorized access to any part or feature of the Site, or any other systems or networks connected to the Site or to any of our servers, or to any of the services offered on or through the Site, by password "mining", hacking or any other illegitimate means.
                  </p>
                </li>
                <li>
                  <p>
                    You may not scan, probe or test the vulnerability of the Site or any network connected to the Site, nor breach the security or authentication measures on the Site or any network connected to the Site.
                  </p>
                </li>
                <li>
                  <p>
                    You may not reverse look-up, trace or seek to trace any information on any other user of or visitor to the Site, or any other customer of ours, to its source, or exploit the Site or any service or information made available or offered by or through the Site, in any way where the purpose is to reveal any information, including but not limited to personal identification or information, other than your own information, as provided for by the Site.
                  </p>
                </li>
                <li>
                  <p>
                    You agree that you will not take any action that imposes an unreasonable or disproportionately large load on the infrastructure of the Site or our systems or networks, or any systems or networks connected to the Site.
                  </p>
                </li>
                <li>
                  <p>
                    You agree not to use any device, software or routine to interfere or attempt to interfere with the proper working of the Site or any transaction being conducted on the Site, or with any other person's use of the Site.
                  </p>
                </li>
                <li>
                  <p>
                    You may not forge headers or otherwise manipulate identifiers in order to disguise the origin of any message or transmittal you send to us on or through the Site or any service offered on or through the Site. You may not pretend that you are, or that you represent, someone else, or impersonate any other individual or entity.
                  </p>
                </li>
                <li>
                  <p>
                    You may not use the Site or any Content for any purpose that is unlawful or prohibited by these Terms of Use, or to solicit the performance of any illegal activity or other activity which infringes our rights or those of others.
                  </p>
                </li>
                <li>
                  <p>
                    The Site is intended for use only by those who can access it from within the UK. If you choose to access the Site from locations outside the UK, you are responsible for compliance with local laws where they are applicable.
                  </p>
                </li>
                <li>
                  <p>
                    You agree that you are solely responsible for:
                  </p>
                  <ol style="list-style-type: lower-roman;">
                    <li>
                      <p>All costs and expenses you may incur in relation to your use of the Site; and</p>
                    </li>
                    <li>
                      <p>Keeping your password and any other account details confidential.</p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    Our services are not targeted towards, nor intended for use by, anyone under the age of 18. If you are under the age of 18, you are not permitted to use our services.
                  </p>
                </li>
                <li>
                  <p>
                     We seek to make the Site as accessible as possible. If you have any difficulties using the Site, please contact us at <a href="mailto:fintransformer@gmail.com">fintransformer@gmail.com</a>.
                  </p>
                </li>
                <li>
                  <p>
                    We may prevent or suspend your access to the Site if you do not comply with any part of these Terms, any terms or policies to which they refer or any applicable law.
                  </p>
                </li>
                <li>
                  <p>
                    You agree not to copy, adapt, modify, reverse-engineer, decompile in any manner, through current or future available technologies, Site software or digital content bought by you.
                  </p>
                </li>
                <li>
                  <p>
                    You agree not to try to extract source code from the Site software or digital content bought by you.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Ownership, use and intellectual property rights
              </h5>
              <ol>
                <li>
                  <p>
                    This Site and all intellectual property rights in it, including but not limited to any Content, are owned by us, our licensors or both (as applicable). We and our licensors reserve all of our and their rights in any intellectual property in connection with these Terms. This means, for example, that we and they remain owners of them and free to use them as we and they see fit.
                  </p>
                </li>
                <li>
                  <p>
                    Nothing in these Terms grants you any legal rights in the Site other than as necessary to enable you to lawfully access the Site as intended and authorized by us. You agree not to adjust to try to circumvent or delete any notices contained on the Site (including any intellectual property notices) and in particular in any digital rights or other security technology embedded or contained within the Site.
                  </p>
                </li>
                <li>
                  <p>
                    Trade marks:
                    <br>
                    The use of any trade marks on the Site is strictly prohibited unless you have our prior written permission.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Submitting information to the Site
              </h5>
              <ol>
                <li>
                  <p>
                    While we try to make sure that the Site is secure, we cannot guarantee the security of any information that you supply to us. We therefore cannot guarantee that it will be kept confidential. For that reason, you should not submit any patentable ideas or patent applications, advertising or marketing suggestions, prototypes, or any other information that you regard as confidential, commercially sensitive or valuable (Unwanted Submissions) to the Site. While we value your feedback, you agree not to submit any Unwanted Submissions.
                  </p>
                </li>
                <li>
                  <p>
                    We may use any Unwanted Submissions as we see reasonably fit on a free-of-charge basis (bear in mind that we have no way of knowing whether such information is confidential, commercially sensitive or valuable because we do not monitor the Site to check for these matters). Therefore, we will not be legally responsible for keeping any Unwanted Submissions confidential nor will we be legally responsible to you or anybody else for any use of such Unwanted Submissions.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Accuracy of information and availability of the Site
              </h5>
              <ol>
                <li>
                  <p>
                    While we try to make sure that the Site is accurate, up-to-date and free from bugs, we cannot guarantee that it will be. Furthermore, we cannot guarantee that the Site will be fit or suitable for any purpose. Any reliance that you may place on the information on this Site is at your own risk.
                  </p>
                </li>
                <li>
                  <p>
                    We may suspend or terminate operation of the Site at any time as we see fit.
                  </p>
                </li>
                <li>
                  <p>
                    You may have certain legal rights when using the Site (such as if the Online terms and conditions for the supply of goods apply to you). These are also known as 'statutory rights' as they are derived from laws such as the Consumer Rights Act 2015. A summary of your key rights is set out at the beginning of the Online terms and conditions of sale.
                  </p>
                </li>
                <li>
                  <p>
                    Content is provided for your general information purposes only and to inform you about us and our products and news, features, services and other websites that may be of interest. It does not constitute technical, financial or legal advice or any other type of advice and should not be relied on for any purposes.
                  </p>
                </li>
                <li>
                  <p>
                    While we try to make sure that the Site is available for your use, we do not promise that the Site is available at all times nor do we promise the uninterrupted use by you of the Site.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Hyperlinks and third party sites
              </h5>
              <p>
                The Site may contain hyperlinks or references to third party websites other than the Site. Any such hyperlinks or references are provided for your convenience only. We have no control over third party websites and accept no legal responsibility for any content, material or information contained in them. The display of any hyperlink and reference to any third party website does not mean that we endorse that third party's website, products or services. Your use of a third party site may be governed by the terms and conditions of that third party site.
              </p>
              <h5 class="content-heading">
                Limitation on our liability
              </h5>
              <p>
                Except for any legal responsibility that we cannot exclude in law (such as for death or personal injury), we are not legally responsible for any losses. This exclusion shall include, but not be limited to:
              </p>
              <ol style="list-style-type: lower-alpha;">
                <li>
                  <p>losses that:</p>
                  <ol style="list-style-type: lower-roman;">
                    <li>
                      <p>
                        were not foreseeable to you and us when these Terms were formed; or
                      </p>
                    </li>
                    <li>
                      <p>
                        that were not caused by any breach on our part
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    business losses; and
                  </p>
                </li>
                <li>
                  <p>
                    losses to non-consumers.
                  </p>
                </li>
              </ol>
              <h5 class="content-heading">
                Events beyond our control
              </h5>
              <p>
                We shall have no liability to you for any breach of these Terms caused by any event or circumstance beyond our reasonable control including, but not limited to, strikes, lock-outs or other industrial disputes; breakdown of systems or network access; or flood, fire, explosion or accident.
              </p>
              <h5 class="content-heading">
                Rights of third parties
              </h5>
              <p>
                No one other than a party to these Terms has any right to enforce any of these Terms.
              </p>
              <h5 class="content-heading">
                Disputes
              </h5>
              <ol>
                <li>
                  <p>
                    We will try to resolve any disputes with you quickly and efficiently.
                  </p>
                </li>
                <li>
                  <p>
                    If you are unhappy with us please contact us as soon as possible.
                  </p>
                </li>
                <li>
                  <p>
                     If you and we cannot resolve a dispute using our complaint handling procedure, we will:
                  </p>
                  <ol style="list-style-type: lower-roman;">
                    <li>
                      <p>
                        let you know that we cannot settle the dispute with you; and
                      </p>
                    </li>
                    <li>
                      <p>
                        give you certain legally required information about our alternative dispute resolution provider which is run by Dubai International Arbitration Centre at:
                      </p>
                      <p class="text-center">
                        Baniyas Road, Deira
                        <br>
                        P. O. Box: 1457
                        <br>
                        Dubai, United Arab Emirates
                      </p>
                      <p>
                        You may also use the online dispute resolution (ODR) platform to resolve the dispute with us. For more details, please visit the website on the 'Your Europe' portal: https://webgate.ec.europa.eu/odr/.consider the need for Alternative Dispute Resolution and, if considered necessary, provide you with information about any alternative dispute resolution provider we deem appropriate to deal with your complaint.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    If you want to take court proceedings, the relevant courts of the United Arab Emirates will have exclusive jurisdiction in relation to these Terms.
                  </p>
                </li>
                <li>
                  <p>
                    Relevant United Arab Emirates law will apply to these Terms.
                  </p>
                </li>
              </ol>
            </div>
            <div class="content" v-if="userLocation !== null &&  userLocation !== 'AE'">
              <p align="justify">
Fintransformer (“<strong>we</strong>” “<strong>our</strong>” or “    <strong>us</strong>”) having its principle place of business at aims to
    bring it business to USA in a way that complies with all the legal and
    regulatory obligations making ease for the entities for cost-effective
    financial translation. These terms of use (the “<strong>Terms</strong>”)
explains our customers and visitors (“<strong>you</strong>” or “    <strong>your</strong>”), the use of our website and all other subdomains
    and associated web pages. Please read these Terms very carefully. By
    proceeding further, you agree to the Terms mentioned hereunder. In case you
    disagree with any portion of these Terms, please stop the use of this
    website immediately.
</p>
<p align="justify">
    You further acknowledge that we do reserve the right at our own discretion
    to amend, modify, add or remove any part or portion of these Terms any time
    without any prior notice and consent. It is your responsibility to check
    these Terms time to time.
</p>
<p align="justify">
    In case you have any query, please feel free to reach us out at
    info@fintransformer.com<em></em>
</p>
<p align="justify">
    1. <strong>Definitions: </strong><strong></strong>
</p>
<p align="justify">
    “<strong>Content</strong>” mean any texts images, videos, audios, or other
    multimedia content software or other information or material submitted to
    or the website.
</p>
<p align="justify">
    “<strong>Cookie Policy</strong>” means the privacy policy, which governs
    the cookie section.
</p>
<p align="justify">
    “<strong>Intellectual Property Right</strong>” or “<strong>IPR</strong>”
    means all the intellectual property rights wherever in the world, whether
    registrable or un-registrable, registered or un-registered including any
    application or right of application for such rights (and these intellectual
    property right’ including copyright and related rights, database rights,
    confidential information, trade secret, know-how, business names,
    trademarks, service marks, passing off rights, unfair competition rights,
    patents, utility models, semi-conductor
</p>
<p align="justify">
    “<strong>Licensors</strong>” mean the entities consisting our licenses to
    reseller our services.
</p>
<p align="justify">
    “<strong>Online terms and conditions of Sale</strong>” means the terms and
    conditions used for the Execution of the Services
</p>
<p align="justify">
    “<strong>Privacy Policy</strong>” means the policy which governs the
    processing of your personal data by us.
</p>
<p align="justify">
    <strong>“Services” </strong>
    means the translation of reports from Russian into English language.
</p>
<p align="justify">
    <strong>“Unwanted Submission” </strong>
    having its meaning under section 7<strong> </strong><strong></strong>
</p>
<p align="justify">
    “<strong>USA</strong>” means the United States of America
</p>
<p align="justify">
    2. <strong>USE OF WEBSITE: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    You acknowledge to as follows:
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    a. This website is for your personal and non-exclusive use only. As long as
    you comply to these Terms, we grant you a personal, non-exclusive,
    non-transferable limited privilege to enter and use the website.
</p>
<p align="justify">
    b. You do not use any “page-scraper”, “robot”, “spider”, “deeper link” or
    other automatic device program, algorithm or methodology or any similar or
    equivalent manual process, to access, copy or acquire or party of the
    website or in any way reproduce or circumvent the navigational structure or
    presentation of the website or any Content, to obtain any materials,
    documents or information through any means not purposely made available
    through the website.
</p>
<p align="justify">
    c. You do not attempt to gain unauthorized access to any part or feature of
    our website or any other systems or networks connected to the website or to
    any of our servers or to any of the Services offered on or through the
    website by password “mining” hacking or any other legitimate means
</p>
<p align="justify">
    d. You do not prove, scan or test the vulnerability of the website or any
    network connected to the website, nor breach the security or authentication
    measures on the website or any network connected to our website.
</p>
<p align="justify">
    e. You must not reverse look-up, trace or seek to trace any information on
    any other user of or visitor to the website, or any other customer of ours,
    to its source, or exploit the website or any service or information made
    available or offered by or through it, in any way where the purpose is to
    reveal any information, including but not limited to personal
    identification or information, other than your own information, as provided
    for by us.
</p>
<p align="justify">
    f. You must not take any action that imposes an unreasonable or
    disproportionately large load on the infrastructure of the website or our
    systems or networks, or any systems or networks connected to the it.
</p>
<p align="justify">
    g. You do not use any device, software or routine to interfere or attempt
    to interfere with the proper working of the website or any transaction
    being conducted on it, or with any other person's use of the website.
</p>
<p align="justify">
    h. You must not forge headers or otherwise manipulate identifiers in order
    to disguise the origin of any message or transmittal you send to us on or
    through the website or any service offered on or through the it. You also
    must not pretend that you are, or that you represent, someone else, or
    impersonate any other individual or entity.
</p>
<p align="justify">
    i. You are present within the region of USA while accessing to the website.
    If you choose to access the website from locations outside the USA, you are
    responsible for compliance with local laws where they are applicable.
</p>
<p align="justify">
    j. You agree that you are solely responsible for:
</p>
<p align="justify">
    i. All costs and expenses you may incur in relation to your use of the
    website; and
</p>
<p align="justify">
    ii. Keeping your password and any other account details confidential.
</p>
<p align="justify">
    k. We reserve the right to prevent or suspend your access to the website
    anytime without any prior not notice, in case, you do not comply with any
    part of these Terms or policies to which they refer or any applicable law.
</p>
<p align="justify">
    l. You do not copy, adapt, modify, reverse-engineer, decompile in any
    manner, through current or future available technologies, website software
    or digital content bought by you.
</p>
<p align="justify">
    m. You agree not to try to extract source code from the website software or
    digital content bought by you.
</p>
<p align="justify">
    3. <strong>YOUR OBLIGATIONS: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    You undertake and warrant:
</p>
<p align="justify">
    i. That the material provided by you is of good quality and error free;
</p>
<p align="justify">
    ii. Not to use any software device to routine to interfere with the proper
    working of the website or which may have a contaminating or detrimental
    effect on the website and our Services.
</p>
<p align="justify">
    iii. That You shall not sub-license the website and our Services without
    our prior written consent
</p>
<p align="justify">
    iv. That the data you provide is authentic and does not infringe any legal
    or regulatory authority.
</p>
<p align="justify">
    4. <strong>INTELLECTUAL PROPERTY RIGHTS: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    a. This website and all other IPR in it, including but not limited to any
    Content, are owned by us, our Licensors or both (as applicable). We and our
    Licensors reserve all rights in any intellectual property in connection
    with these Terms. We grant no rights or licenses (implied, by estoppel or
    otherwise to you under these Terms.
</p>
<p align="justify">
    b. You agree not to adjust to try to circumvent or delete any notices
    contained on the website by us (including any intellectual property
    notices) and in particular in any digital rights or other security
    technology embedded or contained within the website.
</p>
<p align="justify">
    c. Trademarks: The use of any trademark on the website is strictly
    prohibited unless you have our prior written permission.
</p>
<p align="justify">
    5. <strong>ASSOCIATED WEBSITES </strong><strong></strong>
</p>
<p align="justify">
a.    <a href="http://fintransformer.com/cookie-policy"><u>Cookie Policy</u></a>
</p>
<p align="justify">
    b.
    <a href="http://fintransformer.com/tandcsales">
        <u>Terms of use of Services</u>
    </a>
</p>
<p align="justify">
    c.
    <a href="http://fintransformer.com/privacy-policy">
        <u>Privacy Policy</u>
    </a>
</p>
<p>
    6. <strong>HYPERLINKS AND THIRD-PARTY WEBSITES: </strong><strong></strong>
</p>
<p>
    <strong> </strong>
</p>
<p align="justify">
    We may consist third-party hyperlinks or website references on our website.
    You acknowledge that such hyperlinks and references are only provided for
    your convenience and have no control over such Content. The display of any
    hyperlink and reference to any third party website does not mean that we
    endorse that third party's website, products or services. Your use of a
    third party site may be governed by the terms and conditions of that third
    party website.
</p>
<p align="justify">
    7. <strong>COLLECTION OF YOUR DATA</strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    We always intend to ensure that we and our website is safe for you,
    however; we do not guarantee the security of any information that you
    supply to us. Therefore, we also do not guarantee that it will be kept
    confidential. For reason, you acknowledge and agree not submit any
    patentable ideas or patent applications, advertising or marketing
    suggestions, prototypes, or any other information that you regard as
confidential, commercially sensitive or valuable (the “    <strong>Unwanted Submissions</strong>”) to us.
</p>
<p align="justify">
    We may use any Unwanted Submissions as we see reasonably fit on a
    free-of-charge basis (bear in mind that we have no way of knowing whether
    such information is confidential, commercially sensitive or valuable
    because we do not monitor the website to check for these matters).
    Therefore, you agree that we shall not be legally responsible for keeping
    any Unwanted Submissions confidential nor shall we be legally responsible
    to you or anybody else for any use of such Unwanted Submissions.
</p>
<p align="justify">
    You further acknowledge that you are solely responsible for the Content you
    upload in connection with or relating to the Website.
</p>
<p align="justify">
    8. <strong>PAYMENT: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    You agree to pay us as per your subscription package either one-time
    prepaid billing method or monthly billing. Further you acknowledge that all
    the amount to be paid are exclusive of VAT.
</p>
<p align="justify">
    9. <strong>LIMITATION TO LIABILITY: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    a. Except for any legal responsibility that we may not exclude by the law
    i.e. death or any personal injury, we are not legally responsible for any
    losses. This exclusion includes, but is not limited to:
</p>
<p align="justify">
    a. A loss that:
</p>
<p align="justify">
    i. Was not foreseeable to you and us when these Terms are prepared; and
</p>
<p align="justify">
    ii. That was not caused by any breach on our behalf.
</p>
<p align="justify">
    b. Business losses;
</p>
<p align="justify">
    c. Losses to non-consumers.
</p>
<p align="justify">
    10. <strong>REPRESENTATIONS &amp; WARRANTIES: </strong><strong></strong>
</p>
<p align="justify">
    We represent and warrant you that:
</p>
<p align="justify">
    i. we will provide reasonable commercial standards for while providing the
    Services with reasonable skills;
</p>
<p align="justify">
    ii. we do have the legal right and authority to provide the Services; and
</p>
<p align="justify">
    iii. we will comply with all the applicable legal and regulatory
    requirement while providing you the Services and will not breach any laws
    status and regulations applicable under the laws of USA.
</p>
<p align="justify">
    11. <strong>DISCLAIMER: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    a. We try to ensure that the website is accurate, up-to-date and free from
    bugs, however; we do not guarantee the same for future. Furthermore, we do
    not guarantee that our website and Services are fit or suitable for any
    purpose. Any reliance that you may place on the information on this website
    is at your own risk.
</p>
<p>
    b. We may suspend or terminate operation of the website at any time as we
    see fit.
</p>
<p align="justify">
    c. Content is provided for your general information purposes only and to
    inform you about us and our products and news, features, services and other
    websites that may be of interest. It does not constitute technical,
    financial or legal advice or any other type of advice and shall not be
    relied on for any purposes.
</p>
<p>
    d. We try to ensure that the website is available for your use, however; we
    do not promise that the website is available at all times nor do we promise
    the uninterrupted use by you of the website.
</p>
<p>
    12. <strong>FORCE MAJEURE: </strong><strong></strong>
</p>
<p>
    <strong> </strong>
</p>
<p align="justify">
    We shall have no liability to you for any breach of these Terms caused by
    any event or circumstance beyond our reasonable control including, but not
    limited to, strikes, lock-outs or other industrial disputes; breakdown of
    systems or network access; or flood, fire, explosion or accident.
</p>
<p align="justify">
    13. <strong> CHILDERN’S PRIVACY:</strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    Our services are not targeted towards, nor intended for use by, anyone
    under the age of 18. If you are under the age of 18, you are not permitted
    to use our Services.
</p>
<p align="justify">
    14. <strong>INDEMNIFICATION: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    You shall indemnify and shall keep us indemnified against any and all
    liabilities, damages, losses, costs and expenses (including legal expenses
    and amounts reasonably paid in settlement of legal claims) suffered or
    incurred by the us and arising directly or indirectly as a result of any
    breach by you.
</p>
<p align="justify">
    15. <strong>CONTACT US: </strong><strong></strong>
</p>
<p align="justify">
    In case you have any complaint against us, please feel free to reach us out
    at info@fintransformer.com
</p>
<p align="justify">
    16. <strong>LEGITIMATE INTEREST: </strong><strong></strong>
</p>
<p align="justify">
    <strong> </strong>
</p>
<p align="justify">
    You may have certain legal rights when using the website (such as if the
    Online terms and conditions for the supply of goods apply to you). These
    are also known as 'statutory rights' as they are derived from laws such as
    the Consumer Rights Act 2015. A summary of your key rights is set out at
    the beginning of the Online terms and conditions of sale. Nothing in these
    Terms grants you any legal rights in the website other than as necessary to
    enable you to lawfully access the website and the Services as intended and
    authorized by us
    <strong>
        . You agree not to use the website or any Content for any purpose that
        is unlawful or prohibited by these Terms, or to solicit the performance
        of any illegal activity or other activity which infringes our rights or
        those of others
    </strong>
    .
</p>
<p>
    17. <strong>DISPUTES: </strong><strong></strong>
</p>
<p>
    <strong> </strong>
</p>
<p align="justify">
    We ensure to try to resolve any disputes with you quickly and efficiently,
    however; in case we fail to settle the dispute as per mutual discussion, we
    agree to give you certain legally required information about our
    alternative dispute resolution provider which is run by American
    Arbitration Association at 800-778-7879
</p>
<p>
    You may also use the online dispute resolution (ODR) platform to resolve
    the dispute with us. For more details, please visit the website on the
    'Your Europe' portal: https://webgate.ec.europa.eu/odr/.consider the need
    for Alternative Dispute Resolution and, if considered necessary, provide
    you with information about any alternative dispute resolution provider we
    deem appropriate to deal with your complaint.
</p>
<p>
    18. <strong>GOVERNING LAWS AND JURIDICTION: </strong><strong></strong>
</p>
<p>
    <strong> </strong>
</p>
<p>
    These Terms shall be governed as per the applicable laws of USA. In case,
    you desire to take court proceedings, the relevant courts of the USA will
    have exclusive jurisdiction in relation to these Terms.
</p>
              </div>
            </div>
          </div>
        </div>
      </div>

  </section>
</template>

<script>
import axios from 'axios'
export default {
  data: function () {
    return {
      userLocation: null
    }
  },
  methods: {
    async ipLookUp () {
      const response = await axios.get('http://ip-api.com/json')
      this.userLocation = response.data.countryCode
    // console.log('this.userLocation', this.userLocation)
    }
  },
  created () {
    this.ipLookUp()
    this.$store.commit('ISLOADING', false)
  }
}

</script>

<style>

.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}

.hero-image img {
  max-height: 500px;
  width: 100%;
}
p strong {
  /* font-size: 22px; */
    color: #006ac3;
}
p{
  font-family: "Roboto" !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TermsandConditions.vue